<template>
    <div class="overflow-hidden box-content md:px-[60px] lg:px-[100px] relative">
        <div>
            <h3 class="absolute text-sm md:text-lg top-2 left-4 md:top-10 md:left-10 font-semibold uppercase text-teal-500 font-sans">Recruitment</h3>
            <div class="flex flex-row justify-center">
                <div class="pl-4">
                    <p data-aos="fade-right" data-aos-duration="1000" class="float-right text-3xl sm:text-5xl font-semibold md:text-5xl mb-0 text-prime-color"><i>Ứng</i></p> 
                    <p data-aos="fade-right" data-aos-duration="1000" class="pr-1 md:pr-3 text-3xl sm:text-5xl font-semibold md:text-5xl mb-0 text-prime-color"><i>Tuyển</i></p>
                </div>
                <h3 data-aos="fade-left" data-aos-duration="1000" class="text-6xl md:text-[150px] align-middle mt-1 text-prime-color my-auto"><i>HUET</i></h3>
            </div>
        </div>
        <div class="mt-4 md:mt-2">
            <h4 class="font-semibold text-xl lg:text-2xl mb-1">1. Nguyên tắc tuyển dụng</h4>
            <p class="text-lg text-justify" v-html="convertText(config.manageRecruitment.recruitmentPrinciples)"></p>
        </div>
        <div class="my-2">
            <h4 class="font-semibold text-xl lg:text-2xl mb-1">2. Tiêu chuẩn chung</h4>
            <p class="text-lg text-justify" v-html="convertText(config.manageRecruitment.generalStandard)"></p>
        </div>
        <h4 class="font-semibold text-xl lg:text-2xl mb-1">3. Vị trí tuyển dụng</h4>
        <div v-if="!loading" class="mt-2 relative overflow-x-auto border-2 border-gray-300">
            <table class="w-full text-sm text-left text-gray-500 border-0">
                <thead class=" text-gray-700 uppercase text-base lg:text-lg">
                    <tr>
                        <th scope="col" class="px-2 py-1 text-center border-2 border-gray-300">
                            STT
                        </th>
                        <th scope="col" class="px-2 py-1 text-center min-w-[200px] border-2 border-gray-300">
                            Đơn vị
                        </th>
                        <th scope="col" class="px-2 py-1 text-center min-w-[100px] border-2 border-gray-300">
                            Vị trí
                        </th>
                        <th scope="col" class="px-2 py-1 text-center min-w-[120px] border-2 border-gray-300">
                            Số lượng
                        </th>
                        <th scope="col" class="px-2 py-1 text-center min-w-[400px] border-2 border-gray-300">
                            Yêu cầu công việc
                        </th>
                    </tr>
                </thead>
                <tbody class="text-black text-base">
                    <tr v-for="(entry, index) in entries" :key="index" class="text-lg py-2 hover:bg-gray-100 border-2 border-gray-300 rounded-2xl">
                        <th scope="row" class="px-2 py-1 text-center border-r-2 border-gray-300">
                            {{ index+1 }}
                        </th>
                        <td class="px-2 py-1 border-r-2 border-gray-300">
                            {{ entry.name }}
                        </td>
                        <td class="px-2 py-1 text-center border-r-2 border-gray-300">
                            {{ entry.position }}
                        </td>
                        <td class="px-2 py-1 text-center border-r-2 border-gray-300">
                            {{ entry.quantity }}
                        </td>
                        <td class="px-2 py-1 text-justify" v-html="entry.description"></td>
                    </tr>
                    <td v-if="!entries" colspan="5" class="px-2 text-center text-lg md:text-xl text-gray-500 font-semibold">Hiện tại HUET chưa có tin tuyển dụng nào!</td>
                </tbody>
            </table>
        </div>
        <Loading v-else />
    </div>
</template>

<script>
import Loading from '@/components/loading'
import { mapActions } from 'vuex';
export default {
    components: {
        Loading
    },
    props: {
        config: Object
    },
    data() {
        return {
            entries: [],
            loading: true
        }
    },
    methods: {
        ...mapActions('recruitment', ['GetRecruitmentList']),
        async getEntry() {
            const response = await this.GetRecruitmentList()
            if (response.data.code == 200) {
                this.entries = response.data.data
                this.loading = false
            }
        },
        convertText(rawText) {
            return rawText.replace(/\n/g, "<br>");
        }
    },
    created() {
        this.getEntry()
    }
}
</script>